import * as actionTypes from './actionTypes';

export const backgroundTaskVisibilityChanged = (myParam) => {
    return {type: actionTypes.BACKGROUND_TASK_VISIBILITY_CHANGED, payload: myParam};
}
export const backgroundTaskMessageChanged = (myParam) => {
    return {type: actionTypes.BACKGROUND_TASK_MESSAGE_CHANGED, payload: myParam};
}